import { createSlice } from "@reduxjs/toolkit";
import { getIncomeReport } from "services/income/income";

const initialState = {
    income : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const incomeReportSlice = createSlice({
    name: 'income',
    initialState,
    extraReducers: {
        [getIncomeReport.pending]: (state) => {
            state.income.isLoading = true;
        },
        [getIncomeReport.fulfilled]: (state, { payload }) => {
            state.income.isLoading = false;
            state.income.isSuccess = true;
            state.income.data = payload;
        },
        [getIncomeReport.rejected]: (state, { payload }) => {
            state.income.isLoading = false;
            state.income.isSuccess = false;
            state.income.errorMessage = payload
        }
    }
})

export default incomeReportSlice.reducer;